import { Component, Input } from '@angular/core';
import { IUnifiedBackgroundCheckDetail } from '../../../../core/interfaces/unified-background-check.interface';
import { IReportDetails } from '../../driver-background-check.view-models';

@Component({
  selector: 'app-bgc-section-details',
  templateUrl: './bgc-section-details.component.html',
  styleUrls: ['./bgc-section-details.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionDetailsComponent {
  @Input() reportDetails: IReportDetails;
  @Input() detail: IUnifiedBackgroundCheckDetail;
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-details/bgc-section-details.component.ts